<script>import { onMount } from "svelte";
import { flip } from "svelte/animate";
import { dndzone } from "svelte-dnd-action";
import { append } from "../../actions/append.js";
export let type = "";
let dragContainer;
let dragItemMap = /* @__PURE__ */ new Map();
$:
  dragItemList = [];
onMount(() => {
  const dragItems = dragContainer.children;
  Array.from(dragItems).forEach((elem, index) => {
    if (index < dragItems.length - 1) {
      const dragItem = { id: Symbol(), elem };
      dragItemMap.set(dragItem.id, dragItem);
      dragItemList.push(dragItem);
    }
  });
  dragItemList = dragItemList;
});
const flipDurationMs = 300;
function consider(e) {
  dragItemList = e.detail.items;
}
function finalize(e) {
  dragItemList = e.detail.items;
}
</script>

<div bind:this={dragContainer} class="makedraggable re-ordable-list">
    <slot />
    <div
        use:dndzone={{
            items: dragItemList,
            flipDurationMs,
            dropTargetStyle: { outline: "hsla(0,0%,50%,1) dashed 2px" },
            type: type,
        }}
        on:consider={consider}
        on:finalize={finalize}
    >
        {#each dragItemList as item (item.id)}
            <div
                use:append={item.elem}
                animate:flip={{ duration: flipDurationMs }}
            />
        {/each}
    </div>
</div>

<style>
    div.re-ordable-list {
        padding: 5px;
    }
    div.re-ordable-list div {
        margin: 3px;
    }
</style>
